import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function PrivacyPolicy() {
  return (
    <section className="relative py-28 bg-gradient-to-b from-[#0A2A66] via-[#133C91] to-[#0A2A66] text-white overflow-hidden">
      {/* Subtle mesh backdrop (same as Contact/Disclaimer) */}
      <div className="pointer-events-none absolute inset-0 opacity-25 mix-blend-screen">
        <svg
          className="w-full h-full"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
        >
          <defs>
            <pattern
              id="meshGrid"
              width="40"
              height="40"
              patternUnits="userSpaceOnUse"
            >
              <path
                d="M40 0H0V40"
                fill="none"
                stroke="#ffffff"
                strokeOpacity="0.18"
                strokeWidth="1"
              />
            </pattern>
            <radialGradient id="rg" cx="35%" cy="25%" r="70%">
              <stop offset="0%" stopColor="#4bd3ff" stopOpacity="0.32" />
              <stop offset="100%" stopColor="#000" stopOpacity="0" />
            </radialGradient>
          </defs>
          <rect width="100%" height="100%" fill="url(#meshGrid)" />
          <rect width="100%" height="100%" fill="url(#rg)" />
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 leading-relaxed">
        <motion.h1
          className="text-4xl md:text-5xl font-bold mb-10 text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Privacy Policy
        </motion.h1>

        <motion.div
          className="space-y-6 text-white/90 text-lg"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <p>
            At QuantNexusCapital, we respect your privacy and are committed to
            safeguarding any personal information you provide. We only collect
            the minimal data required to respond to your inquiries and deliver
            our services.
          </p>

          <p>
            All communication, including emails and allocation requests, is
            handled with strict confidentiality. We do not sell, rent, or share
            your information with third parties. Your contact details are used
            solely for direct communication related to your request.
          </p>

          <p>
            Our website may use basic, anonymized analytics tools to understand
            general visitor engagement and improve usability. These analytics do
            not identify individuals or track personal browsing behavior.
          </p>

          <p>
            By submitting your details, you consent to us using your information
            exclusively for the purposes outlined above. If at any point you
            wish to withdraw consent or request removal of your information,
            please contact{" "}
            <a
              href="mailto:info@quantnexuscapital.com"
              className="underline text-cyan-300"
            >
              info@quantnexuscapital.com
            </a>
            .
          </p>
        </motion.div>

        {/* Back to Home button */}
        <div className="mt-12 text-center">
          <Link
            to="/"
            className="inline-block px-6 py-3 rounded-xl bg-gradient-to-r from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white font-semibold shadow-lg transition"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
